import { People, PaidSharp, ArrowBackRounded } from "@mui/icons-material";
import { Stack, Box, Divider, Skeleton, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import PaiementJournalier from "../../component/dialog/PaiementJournalier.tsx";
import Header from "./Header";
import { Link, useNavigate } from "react-router-dom";
import { accountService } from "../../_services/accountServices";
import { API_CLASSE } from "../../apiCaller/classe.Caller";
import toast from "react-hot-toast";
import {
  ClasseType,
  EleveType,
  PaiementType,
  PromotionType,
  requestType,
} from "../../types/GlobalType";

import _ from "lodash";

import { API_ELEVE } from "../../apiCaller/eleve.Caller";

import { API_PAIEMENT } from "../../apiCaller/paiement.Caller.js";
import { ANNEE_SCOLAIRE } from "../../App.constants.js";
import { catchErrorApiCall } from "../../_services/apiUtils.js";
import ConnexionErrorDiv from "../../component/nodata/ConnexionErrorDiv.js";
// import SearchBar from "../../component/searchBar/Search.tsx";
import moment from "moment";

const Paiement = () => {
  const [open, setOpen] = React.useState(false);
  const [eleveSearch, setEleveSearch] = useState("");
  const [selectedClasse, setSelectedClasse] = useState("");

  const [classes, setclasses] = useState<ClasseType[]>([]);
  const [eleveData, setEleveData] = React.useState<EleveType[]>([]);
  const [paiementData, setpaiementData] = React.useState<PaiementType[]>([]);

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });
  const [statePaiement, setStatePaiement] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });
  const [stateEleve, setStateEleve] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const fetchAllClasse = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }

    API_CLASSE.CLASSE.getAll(token)
      .then((response) => {
        setState({
          isLoading: false,
          errorMessage: null,
          successMessage: null,
        });

        // let axios_Fake_Response = {
        //   config: null,
        //   data: { data: [], message: "Situation Rapport is Empty" },
        //   status: 205,
        //   statusText: "OK",
        // };

        let empyData = [];

        if (response.data === "") {
          setclasses(empyData);
        } else {
          setclasses(response.data.data);
        }
      })
      .catch((err) => {
        setState({
          isLoading: false,
          successMessage: false,
          errorMessage: false,
        });

        if (err.code === "ERR_NETWORK") {
          return setState({
            ...state,
            errorMessage: "ERR_NETWORK",
          });
        }

        catchErrorApiCall(err);
      });
  };

  const fetchAllEleve = async () => {
    setStateEleve({
      isLoading: true,
      errorMessage: null,
      successMessage: null,
    });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }

    API_ELEVE.PROMOTION.getAll(token)
      .then((response) => {
        let empyData: EleveType[] = [];

        if (response.data === "") {
          setEleveData(empyData);
        } else {
          setEleveData(response.data.data);
        }
      })
      .catch((err) => {
        catchErrorApiCall(err);
      })
      .finally(() => {
        setStateEleve({
          isLoading: false,
          errorMessage: null,
          successMessage: null,
        });
      });
  };

  const fetchAllPaiement = async () => {
    setStatePaiement({
      isLoading: true,
      errorMessage: null,
      successMessage: null,
    });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }

    API_PAIEMENT.PAIEMENT.getAll(token)
      .then((response) => {
        let empyData: PaiementType[] = [];

        if (response.data === "") {
          setpaiementData(empyData);
        } else {
          setpaiementData(response.data.data);
        }
      })
      .catch((err) => {
        catchErrorApiCall(err);
      })
      .finally(() => {
        setStatePaiement({
          isLoading: false,
          errorMessage: null,
          successMessage: null,
        });
      });
  };

  const navigate = useNavigate();

  const handleChange = (e) => {
    setEleveSearch(e.target.value);
  };

  function getPaiementPerMonth() {
    let currentMonth = moment().format("MM");
    let currentYear = moment().format("YYYY");
    let fullCurrentMonth = `${currentYear}-${currentMonth}`;

    const monthPaiement = _.filter(paiementData, (item) =>
      item.paiement_created_at.includes(fullCurrentMonth)
    );

    let data = monthPaiement;
    let size = monthPaiement.length;
    let sum = monthPaiement.reduce(
      (acc: number, curr: PaiementType) => acc + curr.montant,
      0
    );

    return { size, data, sum };
  }

  function getPaiementPerDay() {
    let currentDay = moment().format("YYYY-MM-DD");

    const todayPaiement = _.filter(paiementData, (item) =>
      item.paiement_created_at.includes(currentDay)
    );

    let data = todayPaiement;
    let size = todayPaiement.length;
    let sum = todayPaiement.reduce(
      (acc: number, curr: PaiementType) => acc + curr.montant,
      0
    );

    return { size, data, sum };
  }

  let amountPerMonth: number = getPaiementPerMonth().sum;
  let totalPerMonth: number = getPaiementPerMonth().size;
  let amountPerDay: number = getPaiementPerDay().sum;
  let totalPerDay: number = getPaiementPerDay().size;

  let sortedData: EleveType[] = [];
  if (eleveData.length > 0) {
    sortedData = _.orderBy(eleveData, ["nom"], ["asc"]);
  }

  let filteredData: EleveType[] = [];
  filteredData = _.filter(
    sortedData,
    (item: PromotionType) =>
      item.annee_scolaire_designation ===
        ANNEE_SCOLAIRE[ANNEE_SCOLAIRE.length - 1] &&
      item.classe_designation
        ?.toLowerCase()
        .includes(selectedClasse.toLowerCase())
  );

  useEffect(() => {
    fetchAllClasse();
    fetchAllEleve();
    fetchAllPaiement();
  }, []);

  const handleClick_HistoriqueMensuel = () => {
    setOpen(true);
  };

  const skeletonHeader = (
    <Skeleton
      variant="rounded"
      height={25}
      width={250}
      sx={{ marginTop: "5px", marginRight: "10px" }}
    />
  );
  const skeletonSeachSection = (
    <Skeleton variant="rounded" height={30} width={"100%"} />
  );
  const skeletonTable = (
    <Skeleton
      sx={{ backgroundColor: "#c3c3c3" }}
      variant="rounded"
      height={400}
      width={"100%"}
    />
  );

  const filteredList = filteredData
    .filter(
      (value) =>
        value.nom?.toLowerCase().includes(eleveSearch.toLowerCase()) ||
        value.postnom?.toLowerCase().includes(eleveSearch.toLowerCase()) ||
        value.prenom?.toLowerCase().includes(eleveSearch.toLowerCase()) ||
        value.classe_designation
          ?.toLowerCase()
          .includes(eleveSearch.toLowerCase())
    )
    .filter((value) => value.eleve_status == "1");

  return (
    <>
      {state.errorMessage === "ERR_NETWORK" ? (
        <ConnexionErrorDiv />
      ) : (
        <Box
          bgcolor="#eee"
          flex={5}
          p={1}
          sx={{ marginLeft: "200px", marginTop: "60px" }}
        >
          {/* ------------------PAGE TITLE-------------------- */}

          <Stack direction="row" justifyContent="space-between">
            <div className="homeMenu">
              {state.isLoading ? (
                skeletonHeader
              ) : (
                <>
                  <Link to="/" style={{ marginTop: "5px" }}>
                    <ArrowBackRounded
                      sx={{
                        color: "#0091EA",
                        backgroundColor: "#fff",
                        borderRadius: "50%",
                      }}
                    />
                  </Link>
                  <div className="homeTitleItem">
                    <span className="homeTitle"> Paiement</span>
                  </div>
                  <div className="homeTitleItem2">
                    <PaidSharp sx={{ color: "#1565C0" }} />
                    <span className="homeTitleSmall">
                      Paiement des frais scolaires
                    </span>
                  </div>
                </>
              )}
            </div>
          </Stack>
          <Divider sx={{ marginTop: "3px" }} />

          <Header
            amountPerMonth={amountPerMonth}
            totalPerMonth={totalPerMonth}
            amountPerDay={amountPerDay}
            totalPerDay={totalPerDay}
            onClickHistorique={handleClick_HistoriqueMensuel}
            loading={statePaiement}
          />

          <Stack direction="row" sx={{ margin: ".7rem 0rem" }}>
            {state.isLoading ? (
              skeletonSeachSection
            ) : (
              <div className="paymentContenair">
                <div className="paiementMsg">
                  <div className="iconPaiement">
                    <People sx={{ color: "#888" }} />
                    <span className="classeTitle">Classes</span>
                  </div>
                  <div style={{ marginLeft: "10px" }}>
                    <select
                      defaultValue={selectedClasse}
                      onChange={(e) => setSelectedClasse(e.target.value)}
                      className="selectClasse"
                    >
                      <option value={""}>{"TOUTES"}</option>
                      {classes.map((value, index) => {
                        return (
                          <option key={index} value={value.classe_designation}>
                            {value.classe_designation.toUpperCase()}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="input-class">
                  <input
                    type="text"
                    value={eleveSearch}
                    onChange={handleChange}
                    placeholder=" Rechercher par nom..."
                    className="search-bar"
                  />
                </div>
              </div>
            )}
          </Stack>

          {/* tableau de tous les eleves pour le paiement */}

          {stateEleve.isLoading ? (
            skeletonTable
          ) : (
            <div className="tableList">
              <table style={{ borderCollapse: "collapse" }}>
                <thead
                  style={{
                    backgroundColor: "#EEEEFF",
                    height: "2.5rem",
                  }}
                >
                  <tr style={{ fontSize: 13 }}>
                    <th style={{ textAlign: "left", paddingLeft: "15px" }}>
                      Num
                    </th>
                    <th style={{ textAlign: "left", paddingLeft: "15px" }}>
                      Nom
                    </th>
                    <th style={{ textAlign: "left", paddingLeft: "15x" }}>
                      Post-nom
                    </th>
                    <th style={{ textAlign: "left", paddingLeft: "15x" }}>
                      Prénom
                    </th>
                    {/* <th style={{textAlign:"left"}}>Matricule</th> */}
                    <th style={{ textAlign: "left" }}>Classe</th>
                    <th></th>
                  </tr>
                </thead>

                {eleveData.length > 0 && (
                  <tbody>
                    {filteredList.map((value, index) => {
                      return (
                        <tr className="tabRow" key={index}>
                          <td style={{ textAlign: "left" }}>
                            {`0${index + 1}`}
                          </td>
                          <td style={{ textAlign: "left" }}>{value.nom}</td>
                          <td style={{ textAlign: "left" }}>{value.postnom}</td>
                          <td style={{ textAlign: "left" }}>
                            {value.prenom?.toUpperCase()}
                          </td>
                          {/* <td style={textAlign:"left"}}>{value.eleve_uid}</td> */}
                          <td style={{ textAlign: "left" }}>
                            {value.classe_designation}
                          </td>
                          <td>
                            <Link
                              to={`/paiement/eleve/${value.eleve_id}`}
                              state={{ value, paiementData }}
                            >
                              <Typography
                                sx={{
                                  color: "#fff",
                                  cursor: "pointer",
                                  padding: "2px 3px",
                                  backgroundColor: "#96C0EA",
                                  borderRadius: "3px",
                                  fontSize: "12px",
                                }}
                              >
                                Détail
                              </Typography>
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                )}
              </table>
            </div>
          )}

          {/* dialog montant l'historique mensuelle en cliquant sur historique*/}

          {open && (
            <PaiementJournalier
              setOpen={setOpen}
              dataPaiement={paiementData}
              dataEleve={eleveData}
            />
          )}
        </Box>
      )}
    </>
  );
};

export default Paiement;
